<template>
  <div class="page">
    <problemIndex :problemData="problemData" :view-only="true"></problemIndex>
  </div>
</template>

<script>
import { getStorage } from "@/util/localStor";
import { taskIdData } from "./utils";
import problemIndex from "@/components/problemDetails/problemIndex.vue";
export default {
  components: {
    problemIndex
  },
  data() {
    return {
      problemData: {}, // 问题详情
    };
  },
  created() {
    // 问题详情
    this.problemData = getStorage("problemData");
    // 修改导航跳转路径
    if (sessionStorage.getItem('goBackPath')) {
      this.$route.meta.fatherPath = sessionStorage.getItem('goBackPath');
    }
    //  this.$route.meta.fatherPath = 
    // $(".breadcrumb > div > span:nth-child(2)").click(() => {
    //   this.$router.go(-1);
    // })
  },
  mounted() {},
  methods: {}
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
